// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"04346438","1955":"04346438","2080":"04346438","3631":"04346438","6633":"04346438","6859":"04346438","8138":"04346438","9033":"04346438"}[chunkId] + ".chunk.css";
};